import { AIResponse } from '../types';

export const isCorrectResponse = (review: unknown): review is AIResponse => {
  const correctReview = review as AIResponse;

  return (
    !!correctReview &&
    !!correctReview.explanation &&
    typeof correctReview.finished !== 'undefined'
  );
};

export const isCorrectDiscussionResponse = (
  review: unknown
): review is { answer: string } => {
  const correctReview = review as { answer: string };

  return (
    !!correctReview &&
    !!correctReview.answer &&
    typeof correctReview.answer === 'string'
  );
};
